<template>
  <div id="app">
    <v-snackbar
            timeout="2900"
            top
            dark
            shaped
            v-model="options.show" :color="options.color">
        <v-icon  class="m-1">{{options.icon}}</v-icon>
        {{ options.message }}
    </v-snackbar>
  </div>
</template>

<script>
    import colors from "vuetify/lib/util/colors";

    export default {
      props: {
        params: Object
      },
        data() {
            return {
                options: {
                    type:"success",
                    message: '',
                    color: '#4322221',
                    show: false,
                    icon:''
                }
            }

        },



        created() {
            this.options.show= false
            Object.assign(this.options, this.params)

            if(this.params){
                this.options.show= true

                if(this.params.type==='success'){
                this.options.color=colors.green.darken3
                this.options.icon='fa fa-check-circle'
                if(!this.params.message)
                this.options.message='عملیات با موفقیت انجام شد'
            }else  if(this.params.type==='error'){
                this.options.color=colors.red.base
                    this.options.icon='fa fa-times-circle'
                    if(!this.params.message)
                    this.options.message='خطا در انجام عملیات مجددا تلاش کنید'
            }else  if(this.params.type==='info'){
                this.options.color=colors.grey.darken3
                    this.options.icon='fa fa-info-circle'
                }else  if(this.params.type==='warning'){
                    this.options.icon='fa fa-exclamation-triangle'
                    this.options.color=colors.orange.darken3
            }
            }



        }
    }
</script>
